import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../gfx/Spinner';
import Icon from '../gfx/Icon';
import EditableThumbnail from '../editableMediaThumbnail';
import { createUrl } from '../../utils/createUrl';

export default class VimeoComponent extends Component {
    static propTypes = {
        url: PropTypes.string.isRequired,
        description: PropTypes.string,
        dimensions: PropTypes.object.isRequired,
        onSubmit: PropTypes.func,
        disabled: PropTypes.bool,
        children: PropTypes.node,
    };

    componentDidMount() {
        if (__CLIENT__) {
            const encodedUrl = encodeURIComponent(this.props.url);
            const url = `https://vimeo.com/api/oembed.json?url=${encodedUrl}&width=458&260&autoplay=true&title=false`;
            fetch(url).then((res) => {
                if (res.ok) {
                    res.json().then((data) => {
                        const thumbnailUrl = data.thumbnail_url;
                        const videoHtml = data.html;
                        this.setState({ thumbnailUrl, videoHtml });
                    });
                } else if (res.status === 404) {
                    this.setState({
                        thumbnailUrl: createUrl(
                            'img/no_image_universal_260px.png'
                        ),
                        videoHtml: `<div class="panel panel--warning">
                            Fant ingen Vimeo-video på <a href="${this.props.url}">${this.props.url}</a>.
                            Vanlige årsaker kan være at videoen ikke er offentlig tilgjengelig eller at lenken inneholder skrivefeil.
                        </div>`,
                    });
                }
            });
        }
    }

    state = { playing: false };

    handleClick = () => {
        this.setState({ playing: true });
    };

    handleEditClick = () => {
        this.setState({ playing: false });
    };

    render() {
        return this.state.thumbnailUrl ? (
            <React.Fragment>
                {this.state.playing && (
                    <div
                        className="video-container image-frame"
                        dangerouslySetInnerHTML={{
                            __html: this.state.videoHtml,
                        }}
                    />
                )}
                <EditableThumbnail
                    clickable
                    defaultValue={this.props.description}
                    disabled={this.props.disabled}
                    editClicked={this.handleEditClick}
                    editLabel="Endre beskrivelse"
                    hidden={this.state.playing}
                    imgSrc={this.state.thumbnailUrl}
                    label="Beskrivelse"
                    onClick={this.handleClick}
                    onSubmit={this.props.onSubmit}
                    placeholder="Beskrivelse"
                    playIcon={
                        <div className="play-icon">
                            <Icon height={20} type="play" width={20} />
                        </div>
                    }
                >
                    {this.props.children}
                </EditableThumbnail>
            </React.Fragment>
        ) : (
            <div
                className="flex justify-center align-items-center r-mvm"
                style={{ height: this.props.dimensions.h }}
            >
                <Spinner height={32} width={32} />
            </div>
        );
    }
}
